import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Paper, InputAdornment, IconButton, Container, Link, Select, MenuItem } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { styled } from '@mui/system';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import logo from '../public/Kaleideo-white-logo.png'; // Import logo
import bgVideo from '../public/new-home-page-video.mp4'; // Import your video file here
import GoogleIcon from '@mui/icons-material/Google';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { AUTH_URLS } from '../config/urls';
import { Password } from '@mui/icons-material';
import { Alert } from '@mui/material';

// Replace the static Background component with a Video Background
const VideoBackground = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  zIndex: -1,
  '& video': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    position: 'absolute',
  }
});

const LoginContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '100vh',
  position: 'relative',
});

const LoginForm = styled(Paper)({
  display: 'flex',
  flexDirection: 'column',
  paddingTop: '100px',
  paddingBottom: '100px',
  paddingLeft: '60px',
  paddingRight: '60px',
  borderRadius: '0px',
  width: '400px',
  textAlign: 'center',
  boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.2)',
});

const LogoBox = styled(Box)({
  position: 'absolute',
  top: '20px',
  left: '20px',
  width: '200px',
  '& img': {
    width: '100%',
  },
});

const StyledTextField = styled(TextField)({
  marginBottom: '15px',
  width: '100%',
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      border: 'none', // Remove border
      borderBottom: '1px solid #000', // Add underline
    },
  },
  '& label': {
    color: '#aaa', // Subtle label color
  },
  '& label.Mui-focused': {
    color: '#2196F3', // Focused label color
  },
});

const StyledButton = styled(Button)({
  width: '100%',
  padding: '12px',
  backgroundColor: '#2196F3',
  color: '#fff',
  fontSize: '1rem',
  '&:hover': {
    backgroundColor: '#1976D2',
  },
});

const GoogleButton = styled(Button)({
  width: '100%',
  padding: '10px',
  fontSize: '0.9rem',
  color: '#000',
  backgroundColor: '#fff',
  border: '1px solid #ccc',
  marginTop: '10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    backgroundColor: '#f5f5f5',
  },
});

const StyledSelect = styled(Select)({
    marginBottom: '15px',
    width: '100%',
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: 'none',
        borderBottom: '1px solid #000',
      },
    },
    '& label': {
      color: '#aaa',
    },
    '& label.Mui-focused': {
      color: '#2196F3',
    },
  });
  
  const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [passwordError, setPasswordError] = useState('');
    const [isRegistering, setIsRegistering] = useState(false);
    const [registrationStep, setRegistrationStep] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    
    // Other state variables remain the same
    const [industry, setIndustry] = useState('');
    const [role, setRole] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phone, setPhone] = useState('');
    const [businessName, setBusinessName] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [customRole, setCustomRole] = useState('');


    const handleForgotPassword = () => {
      setError('forgot_password');
    };
    
    
  
    const validatePasswords = () => {
      if (password.length < 8) {
        setPasswordError('Password must be at least 8 characters long');
        return false;
      }
      if (password !== confirmPassword) {
        setPasswordError('Passwords do not match');
        return false;
      }
      setPasswordError('');
      return true;
    };
  
    const handleRegisterStepThree = (e) => {
      e.preventDefault();
      if (validatePasswords()) {
        handleRegister(e);
      }
    };
    
    const history = useHistory();
  
// Update the handleLogin function in your LoginPage component
const handleLogin = async (e) => {
  e.preventDefault();
  setError(''); // Clear previous errors
  setSuccess(''); 
  try {
      // Convert email to lowercase before sending
      const lowercaseEmail = email.toLowerCase();
      
      // Create FormData object for OAuth2 compatibility
      const formData = new FormData();
      formData.append('username', lowercaseEmail); // Convert to lowercase
      formData.append('password', password);

      const response = await axios.post(
        AUTH_URLS.login,
        formData,
        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
      );
      
      localStorage.setItem('token', response.data.access_token);
      setSuccess('Login successful! Redirecting...');
      setTimeout(() => {
          history.push('/explore');
      }, 1500); // Give user time to see success message
  } catch (error) {
      const errorMessage = error.response?.data?.detail || 
                          error.response?.data?.message || 
                          'Login failed. Please check your credentials and try again.';
      setError(errorMessage);
  }
};
  
        const handleRegisterStepOne = (e) => {
            e.preventDefault();
            setError('');
            
            if (!firstName || !lastName || !email || !phone) {
              setError('Please fill in all required fields');
              return;
            }
            
            setRegistrationStep(2);
          };
          
          const handleRegisterStepTwo = (e) => {
            e.preventDefault();
            setError('');
            
            if (!industry || !role) {
              setError('Please select both industry and role');
              return;
            }
            
            setRegistrationStep(3);
          };
  
          const handleRegister = async (e) => {
            e.preventDefault();
            setError(''); // Clear previous errors
            setSuccess(''); // Clear previous success messages
          
            if (!validatePasswords()) {
              return; // Password validation failed
            }
          
            try {
              const userData = {
                email: email.toLowerCase(), // Convert to lowercase
                password,
                first_name: firstName,
                last_name: lastName,
                phone,
                industry,
                role: role === 'Other' ? customRole : role || 'User'
              };
          
              const response = await axios.post(AUTH_URLS.register, userData, {
                headers: {
                  'Content-Type': 'application/json'
                }
              });
              
              if (response.data.message === "User registered successfully") {
                setSuccess('Registration successful! Redirecting to login...');
                setTimeout(() => {
                  setIsRegistering(false);
                  history.push('/login');
                }, 1500);
              }
            } catch (error) {
              const errorMessage = error.response?.data?.detail || 
                                  error.response?.data?.message || 
                                  'Registration failed. Please try again.';
              setError(errorMessage);
            }
          };
  
      const renderRegistrationStep1 = () => (
        <>
        <Box sx={{ display: 'flex', gap: '10px' }}>
          <StyledTextField
            label="First name"
            variant="outlined"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            required
          />
          <StyledTextField
            label="Last name"
            variant="outlined"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required
          />
        </Box>
        <StyledTextField
          label="Email" 
          variant="outlined"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <StyledTextField
          label="Phone Number"
          variant="outlined"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          required
        />
        </>
    );
  
    const renderRegistrationStep2 = () => (
      <>
        <StyledSelect
          value={industry}
          onChange={(e) => setIndustry(e.target.value)}
          displayEmpty
          variant="outlined"
          renderValue={industry !== '' ? undefined : () => "Select industry"}
        >
          <MenuItem value="">Select industry</MenuItem>
          <MenuItem value="tech">Technology</MenuItem>
          <MenuItem value="finance">Finance</MenuItem>
          <MenuItem value="healthcare">Healthcare</MenuItem>
          <MenuItem value="retail">Retail</MenuItem>
        </StyledSelect>
        <StyledSelect
            value={role}
            onChange={(e) => setRole(e.target.value)}
            displayEmpty
            variant="outlined"
            renderValue={role !== '' ? undefined : () => "Select Job Role"}
          >
            <MenuItem value="">Select Job Role</MenuItem>
            <MenuItem value="Data Scientist">Data Scientist</MenuItem>
            <MenuItem value="GeoSpatial Analyst">GeoSpatial Analyst</MenuItem>
            <MenuItem value="Product Manager">Product Manager</MenuItem>
            <MenuItem value="Software Engineer">Software Engineer</MenuItem>
            <MenuItem value="Other">Other</MenuItem>
          </StyledSelect>

          {role === 'Other' && (
            <StyledTextField
              label="Specify your job role"
              variant="outlined"
              value={customRole}
              onChange={(e) => setCustomRole(e.target.value)}
              required
            />
          )}

      </>
    );

    const renderRegistrationStep3 = () => (
        <>
          <StyledTextField
            label="Password"
            type={showPassword ? 'text' : 'password'}
            variant="outlined"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                    {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <StyledTextField
            label="Confirm Password"
            type={showConfirmPassword ? 'text' : 'password'}
            variant="outlined"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)} edge="end">
                    {showConfirmPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          {passwordError && (
            <Typography color="error" variant="body2" sx={{ mt: 1, mb: 1 }}>
              {passwordError}
            </Typography>
          )}
        </>
      );
  
      const handleSubmit = (e) => {
        e.preventDefault();
        if (isRegistering) {
          if (registrationStep === 1) handleRegisterStepOne(e);
          else if (registrationStep === 2) handleRegisterStepTwo(e);
          else handleRegister(e);
        } else {
          handleLogin(e);
        }
      };
    return (
      <LoginContainer>
        <VideoBackground>
         <video autoPlay loop muted playsInline>
           <source src={bgVideo} type="video/mp4" />
           Your browser does not support the video tag.
         </video>
       </VideoBackground>
        <LogoBox>
          <img src={logo} alt="Kaleideo Logo" />
        </LogoBox>
        <LoginForm elevation={3} component="form" onSubmit={handleSubmit}>
          <Typography variant="h5" sx={{ marginBottom: '60px', fontWeight: 'bold', color: '#000' }}>
            {isRegistering ? 'REGISTER' : 'Welcome'}
          </Typography>
          
          {isRegistering ? (
            <>
                            {registrationStep === 1 ? renderRegistrationStep1() : 
                 registrationStep === 2 ? renderRegistrationStep2() : 
                 renderRegistrationStep3()}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                <StyledButton
                  type="submit"
                                    onClick={registrationStep === 1 ? handleRegisterStepOne : 
                             registrationStep === 2 ? handleRegisterStepTwo : 
                             handleRegister}
                  sx={{ flex: 1 }}
                >
                                    {registrationStep === 3 ? 'Register' : 'Continue'}
                </StyledButton>
              </Box>
            </>
          ) : (
            <>
                <StyledTextField
                label="Email or phone"
                variant="outlined"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                error={!!error && !email}
                helperText={error && !email ? 'Email is required' : ''}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton edge="end">
                        <EditIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
                <StyledTextField
                label="Password"
                type={showPassword ? 'text' : 'password'}
                variant="outlined"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                error={!!error && !password}
                helperText={error && !password ? 'Password is required' : ''}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                        {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
<Box sx={{ 
    width: '100%', 
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center' , mt:-1, mb:1}}>

  <Link
    // component="button"
    variant="body2"
    href="https://mail.google.com/mail/?view=cm&fs=1&to=avinash@kaleideo.co&cc=i_parth.mg@kaleideo.co&su=Password%20Reset%20Request"
    target="_blank"
    rel="noopener noreferrer"
    // onClick={handleForgotPassword}
    sx={{ 
      color: '#1976D2', 
      textDecoration: 'none',
      '&:hover': { textDecoration: 'underline' },
      display: 'inline'
    }}
  >
    Forgot password?
  </Link>

  <Link
    href="https://mail.google.com/mail/?view=cm&fs=1&to=avinash@kaleideo.co&cc=i_parth.mg@kaleideo.co"
    target="_blank"
    rel="noopener noreferrer"
    variant="body2"
    sx={{ 
      color: '#1976D2', 
      textDecoration: 'none',
      '&:hover': { textDecoration: 'underline' },
      display: 'inline'
    }}
  >
    Contact admin
  </Link>
</Box>



              <StyledButton type="submit">Sign In</StyledButton>
              {/* <GoogleButton
  variant="outlined"
  startIcon={<GoogleIcon />}
  onClick={() => alert('This Feature is Coming Soon!')}
>
  Continue with Google
</GoogleButton> */}

            </>
          )}
          
          <Typography variant="body2" sx={{ marginTop: '20px' }}>
            {isRegistering ? 'Already have an account? ' : "Don't have an account? "}
            <Link
              sx={{ color: '#1976D2', cursor: 'pointer' }}
              onClick={() => {
                setIsRegistering(!isRegistering);
                setRegistrationStep(1);
              }}
            >
              {isRegistering ? 'Sign in' : 'Sign up'}
            </Link>
          </Typography>
          {error && (
  <Alert 
    severity="error" 
    sx={{ mb: 2, width: '100%' }}
    onClose={() => setError('')}
  >
    {error === 'forgot_password' ? (
      <>
        Please contact{' '}
        <Link 
  href="https://mail.google.com/mail/?view=cm&fs=1&to=avinash@kaleideo.co&cc=i_parth.mg@kaleideo.co&su=Password%20Reset%20Request"
  target="_blank"
  rel="noopener noreferrer"
  sx={{ color: '#d32f2f', fontWeight: 'bold', textDecoration: 'underline' }}
>
  Admin
</Link>
{' '}
        to reset your password.
      </>
    ) : (
      error
    )}
  </Alert>
)}

{success && (
  <Alert 
    severity="success" 
    sx={{ mb: 2, width: '100%' }}
    onClose={() => setSuccess('')}
  >
    {success}
  </Alert>
)}
        </LoginForm>
      </LoginContainer>

      
    );
  };
  
  export default LoginPage;


// import React, { useState } from 'react';
// import { Box, Button, TextField, Typography, Paper, InputAdornment, IconButton, Container, Link, Select, MenuItem } from '@mui/material';
// import EditIcon from '@mui/icons-material/Edit';
// import { styled } from '@mui/system';
// import { useHistory } from 'react-router-dom';
// import axios from 'axios';
// import logo from '../public/Kaleideo-white-logo.png'; // Import logo
// import bgVideo from '../public/new-home-page-video.mp4'; // Import your video file here
// import GoogleIcon from '@mui/icons-material/Google';
// import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import { AUTH_URLS } from '../config/urls';
// import { Password } from '@mui/icons-material';
// import { Alert } from '@mui/material';

// // Replace the static Background component with a Video Background
// const VideoBackground = styled(Box)({
//   position: 'absolute',
//   top: 0,
//   left: 0,
//   width: '100%',
//   height: '100%',
//   overflow: 'hidden',
//   zIndex: -1,
//   '& video': {
//     width: '100%',
//     height: '100%',
//     objectFit: 'cover',
//     position: 'absolute',
//   }
// });

// const LoginContainer = styled(Box)({
//   display: 'flex',
//   justifyContent: 'center',
//   alignItems: 'center',
//   minHeight: '100vh',
//   position: 'relative',
// });

// const LoginForm = styled(Paper)({
//   display: 'flex',
//   flexDirection: 'column',
//   paddingTop: '100px',
//   paddingBottom: '100px',
//   paddingLeft: '60px',
//   paddingRight: '60px',
//   borderRadius: '0px',
//   width: '400px',
//   textAlign: 'center',
//   boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.2)',
// });

// const LogoBox = styled(Box)({
//   position: 'absolute',
//   top: '20px',
//   left: '20px',
//   width: '200px',
//   '& img': {
//     width: '100%',
//   },
// });

// const StyledTextField = styled(TextField)({
//   marginBottom: '15px',
//   width: '100%',
//   '& .MuiOutlinedInput-root': {
//     '& fieldset': {
//       border: 'none', // Remove border
//       borderBottom: '1px solid #000', // Add underline
//     },
//   },
//   '& label': {
//     color: '#aaa', // Subtle label color
//   },
//   '& label.Mui-focused': {
//     color: '#2196F3', // Focused label color
//   },
// });

// const StyledButton = styled(Button)({
//   width: '100%',
//   padding: '12px',
//   backgroundColor: '#2196F3',
//   color: '#fff',
//   fontSize: '1rem',
//   '&:hover': {
//     backgroundColor: '#1976D2',
//   },
// });

// const GoogleButton = styled(Button)({
//   width: '100%',
//   padding: '10px',
//   fontSize: '0.9rem',
//   color: '#000',
//   backgroundColor: '#fff',
//   border: '1px solid #ccc',
//   marginTop: '10px',
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center',
//   '&:hover': {
//     backgroundColor: '#f5f5f5',
//   },
// });

// const StyledSelect = styled(Select)({
//   marginBottom: '15px',
//   width: '100%',
//   '& .MuiOutlinedInput-root': {
//     '& fieldset': {
//       border: 'none',
//       borderBottom: '1px solid #000',
//     },
//   },
//   '& label': {
//     color: '#aaa',
//   },
//   '& label.Mui-focused': {
//     color: '#2196F3',
//   },
// });

// const LoginPage = () => {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [confirmPassword, setConfirmPassword] = useState('');
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [passwordError, setPasswordError] = useState('');
//   const [isRegistering, setIsRegistering] = useState(false);
//   const [registrationStep, setRegistrationStep] = useState(1);
//   const [isLoading, setIsLoading] = useState(false);
  
//   // Other state variables remain the same
//   const [industry, setIndustry] = useState('');
//   const [role, setRole] = useState('');
//   const [firstName, setFirstName] = useState('');
//   const [lastName, setLastName] = useState('');
//   const [phone, setPhone] = useState('');
//   const [businessName, setBusinessName] = useState('');
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState('');

//   const validatePasswords = () => {
//     if (password.length < 8) {
//       setPasswordError('Password must be at least 8 characters long');
//       return false;
//     }
//     if (password !== confirmPassword) {
//       setPasswordError('Passwords do not match');
//       return false;
//     }
//     setPasswordError('');
//     return true;
//   };

//   const handleRegisterStepThree = (e) => {
//     e.preventDefault();
//     if (validatePasswords()) {
//       handleRegister(e);
//     }
//   };
  
//   const history = useHistory();

//   // Update the handleLogin function in your LoginPage component
//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setError(''); // Clear previous errors
//     setSuccess(''); 
//     try {
//       // Create FormData object for OAuth2 compatibility
//       const formData = new FormData();
//       formData.append('username', email); // OAuth2 expects 'username', not 'email'
//       formData.append('password', password);

//       const response = await axios.post(
//         AUTH_URLS.login,
//         formData,
//         { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
//       );
      
//       localStorage.setItem('token', response.data.access_token);
//       setSuccess('Login successful! Redirecting...');
//       setTimeout(() => {
//         history.push('/explore');
//       }, 1500); // Give user time to see success message
//     } catch (error) {
//       const errorMessage = error.response?.data?.detail || 
//                         error.response?.data?.message || 
//                         'Login failed. Please check your credentials and try again.';
//       setError(errorMessage);
//     }
//   };

//   const handleRegisterStepOne = (e) => {
//     e.preventDefault();
//     setError('');
    
//     if (!firstName || !lastName || !email || !phone) {
//       setError('Please fill in all required fields');
//       return;
//     }
    
//     setRegistrationStep(2);
//   };
  
//   const handleRegisterStepTwo = (e) => {
//     e.preventDefault();
//     setError('');
    
//     if (!industry || !role) {
//       setError('Please select both industry and role');
//       return;
//     }
    
//     setRegistrationStep(3);
//   };

//   const handleRegister = async (e) => {
//     e.preventDefault();
//     setError(''); // Clear previous errors
//     setSuccess(''); // Clear previous success messages
  
//     if (!validatePasswords()) {
//       return; // Password validation failed
//     }
  
//     try {
//       const userData = {
//         email,
//         password,
//         first_name: firstName,
//         last_name: lastName,
//         phone,
//         industry,
//         role: role || 'user'
//       };
  
//       const response = await axios.post(AUTH_URLS.register, userData, {
//         headers: {
//           'Content-Type': 'application/json'
//         }
//       });
      
//       if (response.data.message === "User registered successfully") {
//         setSuccess('Registration successful! Redirecting to login...');
//         setTimeout(() => {
//           setIsRegistering(false);
//           history.push('/login');
//         }, 1500);
//       }
//     } catch (error) {
//       const errorMessage = error.response?.data?.detail || 
//                           error.response?.data?.message || 
//                           'Registration failed. Please try again.';
//       setError(errorMessage);
//     }
//   };

//   const renderRegistrationStep1 = () => (
//     <>
//       <Box sx={{ display: 'flex', gap: '10px' }}>
//         <StyledTextField
//           label="First name"
//           variant="outlined"
//           value={firstName}
//           onChange={(e) => setFirstName(e.target.value)}
//           required
//         />
//         <StyledTextField
//           label="Last name"
//           variant="outlined"
//           value={lastName}
//           onChange={(e) => setLastName(e.target.value)}
//           required
//         />
//       </Box>
//       <StyledTextField
//         label="Email" 
//         variant="outlined"
//         value={email}
//         onChange={(e) => setEmail(e.target.value)}
//         required
//       />
//       <StyledTextField
//         label="Phone Number"
//         variant="outlined"
//         value={phone}
//         onChange={(e) => setPhone(e.target.value)}
//         required
//       />
//     </>
//   );

//   const renderRegistrationStep2 = () => (
//     <>
//       <StyledSelect
//         value={industry}
//         onChange={(e) => setIndustry(e.target.value)}
//         displayEmpty
//         variant="outlined"
//         renderValue={industry !== '' ? undefined : () => "Select industry"}
//       >
//         <MenuItem value="">Select industry</MenuItem>
//         <MenuItem value="tech">Technology</MenuItem>
//         <MenuItem value="finance">Finance</MenuItem>
//         <MenuItem value="healthcare">Healthcare</MenuItem>
//         <MenuItem value="retail">Retail</MenuItem>
//       </StyledSelect>
//       <StyledSelect
//         value={role}
//         onChange={(e) => setRole(e.target.value)}
//         displayEmpty
//         variant="outlined"
//         renderValue={role !== '' ? undefined : () => "Select role"}
//       >
//         <MenuItem value="">Select role</MenuItem>
//         <MenuItem value="Super Admin">Super Admin</MenuItem>
//         <MenuItem value="Admin">Admin</MenuItem>
//         <MenuItem value="User">User</MenuItem>
//       </StyledSelect>
//     </>
//   );

//   const renderRegistrationStep3 = () => (
//     <>
//       <StyledTextField
//         label="Password"
//         type={showPassword ? 'text' : 'password'}
//         variant="outlined"
//         value={password}
//         onChange={(e) => setPassword(e.target.value)}
//         required
//         InputProps={{
//           endAdornment: (
//             <InputAdornment position="end">
//               <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
//                 {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
//               </IconButton>
//             </InputAdornment>
//           ),
//         }}
//       />
//       <StyledTextField
//         label="Confirm Password"
//         type={showConfirmPassword ? 'text' : 'password'}
//         variant="outlined"
//         value={confirmPassword}
//         onChange={(e) => setConfirmPassword(e.target.value)}
//         required
//         InputProps={{
//           endAdornment: (
//             <InputAdornment position="end">
//               <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)} edge="end">
//                 {showConfirmPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
//               </IconButton>
//             </InputAdornment>
//           ),
//         }}
//       />
//       {passwordError && (
//         <Typography color="error" variant="body2" sx={{ mt: 1, mb: 1 }}>
//           {passwordError}
//         </Typography>
//       )}
//     </>
//   );

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (isRegistering) {
//       if (registrationStep === 1) handleRegisterStepOne(e);
//       else if (registrationStep === 2) handleRegisterStepTwo(e);
//       else handleRegister(e);
//     } else {
//       handleLogin(e);
//     }
//   };
  
//   return (
//     <LoginContainer>
//       {/* Replace the static Background with the video background */}
//       <VideoBackground>
//         <video autoPlay loop muted playsInline>
//           <source src={bgVideo} type="video/mp4" />
//           Your browser does not support the video tag.
//         </video>
//       </VideoBackground>
      
//       <LogoBox>
//         <img src={logo} alt="Kaleideo Logo" />
//       </LogoBox>
//       <LoginForm elevation={3} component="form" onSubmit={handleSubmit}>
//         <Typography variant="h5" sx={{ marginBottom: '60px', fontWeight: 'bold', color: '#000' }}>
//           {isRegistering ? 'REGISTER' : 'Welcome'}
//         </Typography>
        
//         {isRegistering ? (
//           <>
//             {registrationStep === 1 ? renderRegistrationStep1() : 
//               registrationStep === 2 ? renderRegistrationStep2() : 
//               renderRegistrationStep3()}
//             <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
//               <StyledButton
//                 type="submit"
//                 onClick={registrationStep === 1 ? handleRegisterStepOne : 
//                   registrationStep === 2 ? handleRegisterStepTwo : 
//                   handleRegister}
//                 sx={{ flex: 1 }}
//               >
//                 {registrationStep === 3 ? 'Register' : 'Continue'}
//               </StyledButton>
//             </Box>
//           </>
//         ) : (
//           <>
//             <StyledTextField
//               label="Email or phone"
//               variant="outlined"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               required
//               error={!!error && !email}
//               helperText={error && !email ? 'Email is required' : ''}
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton edge="end">
//                       <EditIcon />
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />
//             <StyledTextField
//               label="Password"
//               type={showPassword ? 'text' : 'password'}
//               variant="outlined"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               required
//               error={!!error && !password}
//               helperText={error && !password ? 'Password is required' : ''}
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
//                       {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />
//             <Typography variant="body2" sx={{ textAlign: 'right', color: '#1976D2', cursor: 'pointer', marginBottom: '20px' }}>
//               Forgot password?
//             </Typography>
//             <StyledButton type="submit">Sign In</StyledButton>
//             <GoogleButton variant="outlined" startIcon={<GoogleIcon />}>
//               Continue with Google
//             </GoogleButton>
//           </>
//         )}
        
//         <Typography variant="body2" sx={{ marginTop: '20px' }}>
//           {isRegistering ? 'Already have an account? ' : "Don't have an account? "}
//           <Link
//             sx={{ color: '#1976D2', cursor: 'pointer' }}
//             onClick={() => {
//               setIsRegistering(!isRegistering);
//               setRegistrationStep(1);
//             }}
//           >
//             {isRegistering ? 'Sign in' : 'Sign up'}
//           </Link>
//         </Typography>
//         {error && (
//           <Alert 
//             severity="error" 
//             sx={{ mb: 2, width: '100%' }}
//             onClose={() => setError('')}
//           >
//             {error}
//           </Alert>
//         )}
//         {success && (
//           <Alert 
//             severity="success" 
//             sx={{ mb: 2, width: '100%' }}
//             onClose={() => setSuccess('')}
//           >
//             {success}
//           </Alert>
//         )}
//       </LoginForm>
//     </LoginContainer>
//   );
// };

// export default LoginPage;